import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";

const stripePromise = loadStripe("pk_live_51PTMH5Ag7UupbnANL2ql5V2ko9shZaTMpIGGbs6e7MOC1o3sx0QQhokQG46AWL1hxaXTB1Ao4NyrnJ25UIBxcX43005BOI3ed8");
var strSecret = "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";
function Checkout({ change })
{
    change();
    const [formData, setFormData] = useState({
    email: "",
    password: ""
  });

  const [errors, setErrors] = useState({});
  const [loggedIn, setLoggedIn] = useState(window.localStorage.getItem('MuckS_LoginState'))
  const [clientSecret, setClientSecret] = useState("");
  const [basket, setBasket] = useState(window.localStorage.getItem('MuckS_Basket'));
  const [basketDisplay, setBasketDisplay] = useState(window.localStorage.getItem('MuckS_Basket'));
  var objBasket = [];
  var ibasketTotal = 0;
  if(basket)
    {
      try 
      {
          objBasket = JSON.parse(basket);
      } 
      catch(error) 
      {
          
      }
    }

    objBasket.forEach(function (item, index) 
    {
      ibasketTotal = ibasketTotal + item.price
    });
    var basketTotal = ibasketTotal;
    const basketItems = objBasket.map((product) =>
      <li className="basketItem" dataid={product.Name}>
         <img alt="basketItem" className="basketImg" src={product.img} />
        <div className="mainBasketPriceContainer">
          <p className="basketTitleCheckout">{product.Name}</p>
          <p className="basketPriceCheckout"> £{(product.price/100).toFixed(2)}</p>
        </div>
        <div className="basketCrossContainer"></div>
      
      </li> 
  );
  const handleInputChange = (e) => {
    const { name, value } = e.target;


    setFormData({
      ...formData,
      [name]: value
    });
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    // Validate email
    if (!formData.email) {
      newErrors.email = "Email is required";
      isValid = false;
    }

    // Validate password
    if (!formData.password) {
      newErrors.password = "Password is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      // Form is valid, you can submit or process the data here
      console.log("Form data:", formData);
      setLoggedIn(formData);
      localStorage.setItem('MuckS_LoginState', formData);
      setLoggedIn(formData);

      // Here set global state
    } else {
      // Form is not valid, display error messages
    }
  };

  const isFormValid = Object.keys(errors).length === 0;

  useEffect(()  => {
    // Create PaymentIntent as soon as the page loads
    fetch('https://mucksucker.com:3001/create-payment-intent', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: objBasket }),
    })
      .then((res) => res.json())
      .then((data) => setClientSecret(data.clientSecret))
      .then(setBasketDisplay((ibasketTotal/100).toFixed(2)));
  }, []);


  const appearance = {
    theme: 'stripe',
    width: '100%'
  };
  const options = {
    clientSecret,
    appearance,
    layout:
    {
      type: 'tabs',
      defaultCollapsed: false,
    }
  };


  return (
    <div className="container">
      <h1>Checkout</h1>
      <div className="checkoutMastercontainer">

        {loggedIn ? (
        <div className="containerCheckout">

            <div className="checkoutListContainer">
                <ul className="mainCheckoutUl">
                    {basketItems}
                </ul>
                <div className="checkoutTotal">
                  <h3 className="totalCheckout">Total = £{basketDisplay}</h3>
                </div>
            </div>
            <div className="checkoutFormContainer">
              {clientSecret && (
                <Elements stripe={stripePromise} options={options}>
                  <CheckoutForm />
                </Elements>
              )}
              </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div>
              <label>Email:</label>
              <input
                type="text"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
              />
              {errors.email && <div className="error">{errors.email}</div>}
            </div>

            <div>
              <label>Password:</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
              />
              {errors.password && <div className="error">{errors.password}</div>}
            </div>

            <button type="submit" disabled={!isFormValid}>
              Login
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default Checkout;